import {
  FacebookLogoIcon,
  InstagramLogoIcon,
  LinkedinLogoIcon,
  YoutubeLogoIcon,
} from '~/components/icons/logos'
import { Button } from '~/components/general/Button'

export const SocialLinks = () => {
  return (
    <ul className="flex p-0 m-0 gap-3">
      <li className="flex">
        <Button
          type={'link'}
          href={'https://www.linkedin.com/company/career-io'}
          target={'_blank'}
          iconRight={<LinkedinLogoIcon className={'!text-neutral-5 group-hover:!text-[#0c1020]'} />}
          color={'transparent'}
          className={'group !border !border-neutral-80 !p-0 !size-12 lg:!size-13 justify-center'}
        />
      </li>
      <li className="flex">
        <Button
          type={'link'}
          href={'https://www.facebook.com/WeAreCareer.io'}
          target={'_blank'}
          iconRight={<FacebookLogoIcon className={'!text-neutral-5 group-hover:!text-[#0c1020]'} />}
          color={'transparent'}
          className={'group !border !border-neutral-80 !p-0 !size-12 lg:!size-13 justify-center'}
        />
      </li>
      <li className="flex">
        <Button
          type={'link'}
          href={'https://www.instagram.com/wearecareerio'}
          target={'_blank'}
          iconRight={
            <InstagramLogoIcon className={'!text-neutral-5 group-hover:!text-[#0c1020]'} />
          }
          color={'transparent'}
          className={'group !border !border-neutral-80 !p-0 !size-12 lg:!size-13 justify-center'}
        />
      </li>
      <li className="flex">
        <Button
          type={'link'}
          href={'https://www.youtube.com/channel/UCdrdq37J_Y03ca0O3Ma9B3w'}
          target={'_blank'}
          iconRight={<YoutubeLogoIcon className={'!text-neutral-5 group-hover:!text-[#0c1020]'} />}
          color={'transparent'}
          className={'group !border !border-neutral-80 !p-0 !size-12 lg:!size-13 justify-center'}
        />
      </li>
    </ul>
  )
}
